import isNullOrUndefined from "_shared/_utilities/is-null-or-undefined";
import AHDate from "_shared/dates/date";
import AssistantResponseSchema, { AssistantResponseJSON, AssistantResponseParams } from "ai-assistant/assistant-response-schema";
import AssistantCitation from "ai-assistant/citations/assistant-citation";
import { Role } from "ai-assistant/roles/roles";

export default class AssistantResponse {
  public static create(values: AssistantResponseParams): AssistantResponse {
    const parsed = AssistantResponseSchema.validate(values);
    if (isNullOrUndefined(parsed)) {
      throw new Error("Invalid AssistantResponse parameters.");
    }
    return new AssistantResponse(parsed);
  }

  public static fromJSON(json: AssistantResponseJSON): AssistantResponse {
    if (isNullOrUndefined(json)) return json;
    const params = AssistantResponseSchema.deserialize(json);
    return new AssistantResponse(params);
  }

  public readonly responseId: string | undefined;
  public readonly role: Role;
  public readonly text: string;
  public readonly citations: AssistantCitation[];
  public readonly timestamp: AHDate = new AHDate();

  public constructor(params: AssistantResponseParams) {
    this.responseId = params.responseId;
    this.role = params.role;
    this.text = params.text;
    this.citations = params.citations.map(citation => AssistantCitation.create(citation));
    this.timestamp = params.timestamp;
  }

  public toJSON(): AssistantResponseJSON {
    return AssistantResponseSchema.serialize(this);
  }

  public isEqualTo(other: AssistantResponse): boolean {
    return ((!this.responseId && !other.responseId) || (this.responseId === other.responseId))
      && (
        this.role === other.role
        && this.text === other.text
        && this.timestamp.isEqualTo(other.timestamp)
      );
  }

  public toString(): string {
    return `
      Response ID: ${this.responseId}, 
      Role: ${this.role}, 
      Text: ${this.text},
      Citations: ${this.citations.map(citation => citation.toString()).join(", ")},
      Timestamp: ${this.timestamp.toISOString()}
    `;
  }
}
